import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Form, Field, FormSpy } from 'react-final-form';
import { FORM_ERROR } from 'final-form';
import isEqual from 'lodash/isEqual';
import { connect } from 'react-redux';
import { TextField, CheckboxField } from '../../atoms';
import { Row, Col, Button, Spin, Modal } from 'antd';
import {
  FORM_REGISTER_GENERAL,
  formRegisterGeneralFields,
} from '../../constants/formRegister';
import { RegisterActions } from '../../components';
import {
  updateLegalEntityActionCreator,
  addLegalEntity,
  activateLegalEntity,
  deactivateLegalEntity,
  fetchCompanyDataFromBusinessRegisterActionCreator,
} from '../../actions/actionCreators/registerActionCreators';
import { ManualGoIssuing, ManualElectricGosIssuing } from '../../containers';
import {
  getRecalculateElectricGosModal,
  showRecalculateElectricGosModal,
  hideRecalculateElectricGosModal,
  getRecalculateGoModal,
  hideRecalculateGoModal,
  showRecalculateGoModal,
} from '../../actions/actionCreators/modalsActionCreators';
import {
  legalEntityFields,
  businessRegisterFields,
  REGISTER_CODE_LENGTH,
} from '../../constants/legalEntity';
import * as registerSelectors from '../../reducers/registerReducer';
import legalEntityStatuses from '../../constants/classificators/legalEntityStatus';
import { getLoadingSelector } from '../../utils/asyncHelpers';
import { parseNumber } from '../../utils/formHelpers';
import {
  formValueSelector,
  getRffFormValues,
  clearFormState,
} from '../../reducers/reactFinalFormReducer';
import { makeRffValidateFromLegacy } from '../rffLegacyValidateAdapter';
import FormStateToRedux from '../FormStateToRedux';
import validateSchema from './validateSchema';
import classifiersStore from '../../utils/classifiersStore';
import './RegisterGeneral.css';

export class RegisterGeneral extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    isAdmin: PropTypes.bool.isRequired,
    isLoading: PropTypes.bool.isRequired,
    isEditMode: PropTypes.bool,
    hasPrevious: PropTypes.bool,
    hasDone: PropTypes.bool,
    goPrevious: PropTypes.func,
    initialValues: PropTypes.object,
    activate: PropTypes.func.isRequired,
    deactivate: PropTypes.func.isRequired,
    showRequestChangeModal: PropTypes.func,
    registerCode: PropTypes.string,
    showRecalcElectricGosModal: PropTypes.func.isRequired,
    hideRecalcElectricGosModal: PropTypes.func.isRequired,
    isRecalcElectricGosModalVisible: PropTypes.bool.isRequired,
    showRecalcGoModal: PropTypes.func.isRequired,
    hideRecalcGoModal: PropTypes.func.isRequired,
    isRecalcGoModalVisible: PropTypes.bool.isRequired,
    isLoadingOperatorSelected: PropTypes.bool,
    isManufacturerSelected: PropTypes.bool,
    isHydrogenManufacturerSelected: PropTypes.bool,
    isTraderSelected: PropTypes.bool,
    eecsCodeTrader: PropTypes.string,
    eecsCodeProducer: PropTypes.string,
    updateLegalEntity: PropTypes.func.isRequired,
    addLegalEntity: PropTypes.func.isRequired,
    clearFormState: PropTypes.func.isRequired,
    fetchCompanyData: PropTypes.func.isRequired,
    onSubmitSuccess: PropTypes.func,
  };

  static defaultProps = {
    registerCode: '',
  };

  constructor(props) {
    super(props);

    this.state = {
      isConfirmModalVisibleTrader: false,
      isConfirmModalVisibleProvider: false,
    };

    // Seed from the merged initialValues (baseInitial + persisted) so a FormSpy mount
    // tick with the same code does not re-trigger BR fetch on Previous→return.
    this._prevRegisterCode =
      props.initialValues?.[formRegisterGeneralFields.REGISTER_CODE];
  }

  handleTraderCheckboxChange(e) {
    this.setState({
      isConfirmModalVisibleTrader: !e.target.checked,
    });
  }

  handleProviderCheckboxChange(e) {
    this.setState({
      isConfirmModalVisibleProvider: !e.target.checked,
    });
  }

  handleFormChange = (values, form) => {
    const code = values[formRegisterGeneralFields.REGISTER_CODE];
    const id = values[formRegisterGeneralFields.ID];
    if (id) {
      this._prevRegisterCode = code;
      return;
    }
    if (code === this._prevRegisterCode) return;
    this._prevRegisterCode = code;

    if (code?.length === REGISTER_CODE_LENGTH) {
      this.props.fetchCompanyData(code, form.change);
    } else {
      businessRegisterFields.forEach((key) => form.change(key, null));
    }
  };

  onSubmit = async (values) => {
    const result = values[legalEntityFields.ID]
      ? await this.props.updateLegalEntity(values)
      : await this.props.addLegalEntity(values);

    if (result?.error) {
      return { [FORM_ERROR]: 'submitFailed' };
    }
    this.props.clearFormState(FORM_REGISTER_GENERAL);
    this.props.onSubmitSuccess?.();
  };

  render() {
    const {
      hasPrevious,
      hasDone,
      goPrevious,
      t,
      isEditMode,
      isAdmin,
      isLoadingOperatorSelected,
      isManufacturerSelected,
      isHydrogenManufacturerSelected,
      isTraderSelected,
      initialValues,
      isLoading,
      activate,
      deactivate,
      showRequestChangeModal,
      registerCode,
      showRecalcElectricGosModal,
      hideRecalcElectricGosModal,
      isRecalcElectricGosModalVisible,
      showRecalcGoModal,
      hideRecalcGoModal,
      isRecalcGoModalVisible,
      eecsCodeTrader,
      eecsCodeProducer,
    } = this.props;

    const inEditForNotAdmin = isEditMode && !isAdmin;
    const legalEntityStatus = initialValues[formRegisterGeneralFields.STATUS];
    const legalEntityId = initialValues[formRegisterGeneralFields.ID];
    const isNew = registerCode === '';

    const { isConfirmModalVisibleTrader, isConfirmModalVisibleProvider } =
      this.state;

    const validate = makeRffValidateFromLegacy(
      validateSchema,
      this.props,
      initialValues
    );

    return (
      <Spin spinning={isLoading}>
        <Form
          onSubmit={this.onSubmit}
          validate={validate}
          initialValues={initialValues}
          initialValuesEqual={isEqual}
          keepDirtyOnReinitialize
          render={({ handleSubmit, form }) => (
            <form className="form-register-general" onSubmit={handleSubmit}>
              <FormStateToRedux form={FORM_REGISTER_GENERAL} />
              <FormSpy
                subscription={{ values: true }}
                onChange={({ values }) => this.handleFormChange(values, form)}
              />
              <h2 className="form-register-general__title">
                {inEditForNotAdmin
                  ? t('general.titleView')
                  : t('general.title')}
              </h2>
              <Row gutter={32}>
                <Col className="gutter-row" span={4}>
                  <Field
                    label={t('general.isTrader')}
                    name={formRegisterGeneralFields.IS_TRADER}
                    type="checkbox"
                    component={CheckboxField}
                    disabled={inEditForNotAdmin}
                    hasFeedback={false}
                    onChange={this.handleTraderCheckboxChange.bind(this)}
                  />
                </Col>
                <Col className="gutter-row" span={4}>
                  <Field
                    label={t('general.isManufacturer')}
                    name={formRegisterGeneralFields.IS_MANUFACTURER}
                    type="checkbox"
                    component={CheckboxField}
                    disabled={inEditForNotAdmin}
                    hasFeedback={false}
                  />
                </Col>
                {classifiersStore.getBooleanProperty('IS_HYDROGEN_ENABLED') && (
                  <Col className="gutter-row" span={4}>
                    <Field
                      label={t('general.isHydrogenManufacturer')}
                      name={formRegisterGeneralFields.IS_HYDRO_MANUFACTURER}
                      type="checkbox"
                      component={CheckboxField}
                      disabled={inEditForNotAdmin}
                      hasFeedback={false}
                    />
                  </Col>
                )}
                <Col className="gutter-row" span={4}>
                  <Field
                    label={t('general.isProvider')}
                    name={formRegisterGeneralFields.IS_PROVIDER}
                    type="checkbox"
                    component={CheckboxField}
                    disabled={inEditForNotAdmin}
                    hasFeedback={false}
                    onChange={this.handleProviderCheckboxChange.bind(this)}
                  />
                </Col>
                <Col className="gutter-row" span={4}>
                  <Field
                    label={t('general.isOperator')}
                    name={formRegisterGeneralFields.IS_LOADING_OPERATOR}
                    type="checkbox"
                    component={CheckboxField}
                    disabled={inEditForNotAdmin}
                    hasFeedback={false}
                  />
                </Col>
                <Col className="gutter-row" span={12}>
                  <Field
                    name={formRegisterGeneralFields.REGISTER_CODE}
                    component={TextField}
                    type="text"
                    parse={parseNumber}
                    placeholder={t('general.register_code_placeholder')}
                    label={t('general.register_code_label')}
                    disabled={!isNew}
                  />
                </Col>
              </Row>
              <Row gutter={32}>
                <Col className="gutter-row" span={12}>
                  <Field
                    name={formRegisterGeneralFields.COMPANY_NAME}
                    component={TextField}
                    type="text"
                    placeholder={t('general.company_name_placeholder')}
                    label={t('general.company_name_label')}
                    disabled={false}
                  />
                </Col>
                <Col className="gutter-row" span={12}>
                  <Field
                    name={formRegisterGeneralFields.KMKR_CODE}
                    component={TextField}
                    type="text"
                    label={t('general.kmkr_code_label')}
                    tooltip={t('general.kmkr_code_tooltip')}
                    disabled={inEditForNotAdmin}
                  />
                </Col>
              </Row>
              <Row gutter={32}>
                <Col className="gutter-row" span={12}>
                  <Field
                    name={legalEntityFields.BUSINESS_FORM}
                    component={TextField}
                    type="text"
                    label={t('general.businessFrom')}
                    disabled={false}
                  />
                </Col>
                {(isManufacturerSelected || isTraderSelected) && (
                  <Col className="gutter-row" span={12}>
                    <Field
                      name={formRegisterGeneralFields.EICX_CODE_B}
                      component={TextField}
                      type="text"
                      placeholder={t('general.eicx_code_b_placeholder')}
                      label={t('general.eicx_code_b_label')}
                      disabled={!isAdmin}
                    />
                  </Col>
                )}
              </Row>
              <Row gutter={32}>
                <Col className="gutter-row" span={12}>
                  {(isManufacturerSelected || isHydrogenManufacturerSelected) &&
                    (isAdmin || isEditMode) &&
                    (isAdmin || eecsCodeProducer) && (
                      <Field
                        name={formRegisterGeneralFields.EECS_CODE_PRODUCER}
                        component={TextField}
                        type="text"
                        placeholder={t(
                          'general.eecs_code_producer_placeholder'
                        )}
                        label={t('general.eecs_code_producer_label')}
                        disabled={!isAdmin}
                      />
                    )}
                  {isTraderSelected &&
                    (isAdmin || isEditMode) &&
                    (isAdmin || eecsCodeTrader) && (
                      <Field
                        name={formRegisterGeneralFields.EECS_CODE_TRADER}
                        component={TextField}
                        type="text"
                        placeholder={t('general.eecs_code_trader_placeholder')}
                        label={t('general.eecs_code_trader_label')}
                        disabled={!isAdmin}
                      />
                    )}
                </Col>
                {isLoadingOperatorSelected && (
                  <Col className="gutter-row" span={12}>
                    <Field
                      name={formRegisterGeneralFields.EICX_CODE_E}
                      component={TextField}
                      type="text"
                      placeholder={t('general.eicx_code_e_placeholder')}
                      label={t('general.eicx_code_e_label')}
                      disabled={!isAdmin}
                    />
                  </Col>
                )}
              </Row>
              <Row gutter={32}>
                <Col className="gutter-row" span={12}>
                  {isLoadingOperatorSelected && (
                    <Field
                      name={formRegisterGeneralFields.ELECTRIC_GOS_AUTO_ISSUE}
                      type="checkbox"
                      component={CheckboxField}
                      disabled={inEditForNotAdmin}
                      hasFeedback={false}
                      checkboxText={t('general.electricGOSAutoIssue')}
                    />
                  )}
                </Col>
              </Row>

              <RegisterActions
                hasPrevious={hasPrevious}
                hasDone={hasDone}
                hasExit={!isEditMode && isAdmin}
                goPrevious={goPrevious}
                isEditMode={isEditMode}
                isAdmin={isAdmin}
                showSaveButton={isAdmin || !isEditMode}
                showRequestChangeModal={showRequestChangeModal}
                t={t}
              >
                {isEditMode && isAdmin && (
                  <React.Fragment>
                    {isLoadingOperatorSelected && (
                      <Button
                        size="large"
                        type="primary"
                        onClick={showRecalcElectricGosModal}
                      >
                        {t('general.refreshEAVPData')}
                      </Button>
                    )}
                    <Button
                      size="large"
                      type="primary"
                      onClick={showRecalcGoModal}
                    >
                      {t('general.refreshGAVPData')}
                    </Button>
                    <Button
                      size="large"
                      type="primary"
                      onClick={
                        legalEntityStatus === legalEntityStatuses.ACTIVE
                          ? () => deactivate(legalEntityId)
                          : () => activate(legalEntityId)
                      }
                    >
                      {legalEntityStatus === legalEntityStatuses.ACTIVE
                        ? t('general.deactivateBtn')
                        : t('general.activateBtn')}
                    </Button>
                  </React.Fragment>
                )}
              </RegisterActions>
            </form>
          )}
        />
        {isRecalcElectricGosModalVisible && (
          <Modal
            onCancel={hideRecalcElectricGosModal}
            open
            footer={false}
            title={t('general.modalPriceTitle')}
            width="800px"
          >
            <ManualElectricGosIssuing
              onDone={hideRecalcElectricGosModal}
              legalEntityId={legalEntityId}
            />
          </Modal>
        )}
        {isRecalcGoModalVisible && (
          <Modal
            onCancel={hideRecalcGoModal}
            open
            footer={false}
            title={t('general.modalPriceTitle')}
            width="800px"
          >
            <ManualGoIssuing
              onDone={hideRecalcGoModal}
              legalEntityId={legalEntityId}
            />
          </Modal>
        )}
        <Modal
          closable={false}
          title={t('general.modalConfirmTitle')}
          open={isConfirmModalVisibleProvider || isConfirmModalVisibleTrader}
          footer={false}
        >
          <div style={{ textAlign: 'center' }}>
            <p>{t('general.modalConfirmTxt')}</p>
            <br />
            <Button
              type="primary"
              onClick={() =>
                this.setState({
                  isConfirmModalVisibleProvider: false,
                  isConfirmModalVisibleTrader: false,
                })
              }
            >
              OK
            </Button>
          </div>
        </Modal>
      </Spin>
    );
  }
}

const valueSelector = formValueSelector(FORM_REGISTER_GENERAL);

const getBrFetchLoading = getLoadingSelector(
  registerSelectors.getFetchFromBr,
  registerSelectors.getActivationState
);

const mapStateToProps = (state, props) => {
  const legalEntity = props.legalEntity;
  const baseInitial = legalEntity?.toJS
    ? legalEntity.toJS()
    : legalEntity || {};
  const persisted = getRffFormValues(state, FORM_REGISTER_GENERAL).toJS();
  const persistedId = persisted[formRegisterGeneralFields.ID];
  const baseId = baseInitial[formRegisterGeneralFields.ID];
  const isStaleEntity = persistedId != null && persistedId !== baseId;
  return {
    initialValues: isStaleEntity
      ? baseInitial
      : { ...baseInitial, ...persisted },
    isLoadingOperatorSelected: valueSelector(
      state,
      formRegisterGeneralFields.IS_LOADING_OPERATOR
    ),
    isManufacturerSelected: valueSelector(
      state,
      formRegisterGeneralFields.IS_MANUFACTURER
    ),
    isHydrogenManufacturerSelected: valueSelector(
      state,
      formRegisterGeneralFields.IS_HYDRO_MANUFACTURER
    ),
    eecsCodeTrader: valueSelector(
      state,
      formRegisterGeneralFields.EECS_CODE_TRADER
    ),
    eecsCodeProducer: valueSelector(
      state,
      formRegisterGeneralFields.EECS_CODE_PRODUCER
    ),
    isTraderSelected: valueSelector(state, formRegisterGeneralFields.IS_TRADER),
    isLoading: getBrFetchLoading(state),
    isRecalcElectricGosModalVisible: getRecalculateElectricGosModal(state),
    isRecalcGoModalVisible: getRecalculateGoModal(state),
  };
};

const mapDispatchToProps = {
  activate: activateLegalEntity,
  deactivate: deactivateLegalEntity,
  showRecalcElectricGosModal: showRecalculateElectricGosModal,
  hideRecalcElectricGosModal: hideRecalculateElectricGosModal,
  showRecalcGoModal: showRecalculateGoModal,
  hideRecalcGoModal: hideRecalculateGoModal,
  updateLegalEntity: updateLegalEntityActionCreator,
  addLegalEntity,
  clearFormState,
  fetchCompanyData: fetchCompanyDataFromBusinessRegisterActionCreator,
};

export default connect(mapStateToProps, mapDispatchToProps)(RegisterGeneral);
